<template>
  <div id="admin-report">

    <vs-popup classContent="popup-example flex flex-wrap justify-center" title="แจ้งเตือน"
              :active.sync="popupNoDataActive">
      <vs-row class="py-2">ไม่พบข้อมูล ณ ช่วงเวลาที่เลือก</vs-row>
    </vs-popup>
    <vs-popup classContent="popup-example flex flex-wrap justify-center" title="แจ้งเตือน"
              :active.sync="popupNoVillageActive">
      <vs-row class="py-2">ไม่พบหมู่บ้าน</vs-row>
    </vs-popup>
    <vs-popup classContent="popup-example flex flex-wrap justify-center" title="แจ้งเตือน"
              :active.sync="popupNoFilterActive">
      <vs-row class="py-2">กรุณากรอกหมู่บ้านหรือช่วงเวลาที่ต้องการค้นหา</vs-row>
    </vs-popup>

    <div class="router-header flex flex-wrap items-center mb-6">
      <div class="content-area__heading">
        <h2 class="mb-1">รายงาน</h2>
      </div>
    </div>

    <div class="vx-card mb-8">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <vs-input label="จุดตรวจวัด" class="w-full mb-4" icon-pack="feather" list="geoJsons" icon="icon-search"
                        v-model="filterMeasuringPoint"
                        icon-no-border/>
              <datalist id="geoJsons">
                <option :key="index" v-for="(item,index) in villages" :value="item.name"></option>
              </datalist>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label for="" class="vs-select--label">ข้อมูลวันที่เริ่มต้น</label>
              <datepicker :disabledDates="disabledDates" v-model="filterStartDate" class="w-full mb-4"
                          :minimumView="'day'" :maximumView="'month'"
                          :language="languages[language]" format="d MMMM yyyy"></datepicker>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label for="" class="vs-select--label">ข้อมูลช่วงเวลาเริ่มต้น</label>
              <flat-pickr class="w-full mb-4" :config="configdateTimePicker" v-model="filterStartTime"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label for="" class="vs-select--label">ข้อมูลวันที่สิ้นสุด</label>
              <datepicker :disabledDates="disabledDates" v-model="filterEndDate" class="w-full mb-4"
                          :minimumView="'day'" :maximumView="'month'"
                          :language="languages[language]" format="d MMMM yyyy"></datepicker>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label for="" class="vs-select--label">ข้อมูลช่วงเวลาสิ้นสุด</label>
              <flat-pickr class="w-full mb-4" :config="configdateTimePicker" v-model="filterEndTime"/>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full flex flex-wrap items-center">
              <vs-button class="mb-4 md:mb-0 mr-4" @click="filterData">ค้นหา</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card p-6 mb-8">
      <div class="flex items-center justify-end ag-grid-table-actions-right">
        <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="ค้นหา..."/>
        <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export</vs-button>
      </div>

      <div id="div-with-loading" class="vs-con-loading__container">
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="reports"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="false"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl">
        </ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"/>
      </div>

    </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {AgGridVue} from 'ag-grid-vue'
import moment from 'moment'

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import {mapState} from "vuex";

export default {
  components: {
    Datepicker,
    flatPickr,
    AgGridVue
  },
  data: () => ({
    popupNoDataActive: false,
    popupNoVillageActive: false,
    popupNoFilterActive: false,
    filterMeasuringPoint: '',
    filterStartDate: '',
    filterStartTime: '',
    filterEndDate: '',
    filterEndTime: '',
    searchQuery: '',
    gridOptions: {},
    maxPageNumbers: 7,
    gridApi: null,
    defaultColDef: {
      sortable: true,
      editable: true,
      resizable: true,
      suppressMenu: true
    },
    columnDefs: [
      {
        headerName: 'จุดตรวจวัด',
        field: 'government_name',
        filter: true,
        width: 300
      },
      {
        headerName: 'หมู่บ้าน',
        field: 'village_name',
        filter: true,
        width: 150
      },
      {
        headerName: 'ตำบล',
        field: 'subdistrict_name',
        width: 100,
        filter: true,
        checkboxSelection: false,
        headerCheckboxSelectionFilteredOnly: false,
        headerCheckboxSelection: false
      },
      {
        headerName: 'ข้อมูลวันที่',
        field: 'date_format',
        filter: true,
        width: 125
      },
      {
        headerName: 'เวลา',
        field: 'time_format',
        filter: true,
        width: 100
      },
      {
        headerName: 'AQI',
        field: 'aqi',
        filter: true,
        width: 100
      },
      {
        headerName: 'PM2.5',
        field: 'pm25',
        filter: true,
        width: 100
      },
      {
        headerName: 'PM10',
        field: 'pm10',
        filter: true,
        width: 100
      },
      {
        headerName: 'อุณหภูมิ(°c)',
        field: 'temp',
        filter: true,
        width: 125
      },
      {
        headerName: 'ความชื้นสัมพัทธ์(%)',
        field: 'rh',
        filter: true,
        width: 180
      },
      {
        headerName: 'CO(ระดับความปลอดภัย)',
        field: 'cotext',
        filter: true,
        width: 200
      },
      {
        headerName: 'NO2(ระดับความปลอดภัย)',
        field: 'no2text',
        filter: true,
        width: 210
      }
    ],
    date: null,
    language: 'th',
    languages: lang,
    configdateTimePicker: {
      enableTime: true,
      enableSeconds: false,
      noCalendar: true,
      time_24hr: true
    },
    disabledDates: {// Disable all dates up to specific date
      from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1) // Disable all dates after specific date
    },
    selected: [],
    log: []
  }),
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    filterData() {
      const name = this.filterMeasuringPoint

      // const map = this.maps.features.find(f => f.properties.name.includes(this.filterMeasuringPoint))
      let map = this.villages.filter(function (item) {
        return item.name === name
      })
      let map_searched = ''
      if (map.length > 0) {
        map_searched = map[0].id
      }
      if (map.length < 1 && name) {
        this.popupNoVillageActive = true
      }

      if (!this.filterMeasuringPoint && !this.filterStartDate && !this.filterEndDate) {
        this.popupNoFilterActive = true
      }

      this.$store.dispatch('admin_api/filterReport', {
        filterMeasuringPoint: map_searched,
        filterStartDate: this.filterStartDate,
        filterStartTime: this.filterStartTime,
        filterEndDate: this.filterEndDate,
        filterEndTime: this.filterEndTime
      }).catch((res) => {
        if (res.error == 'record not found') {
          this.popupNoDataActive = true
        }
      })
    },
    openLoadingInDiv() {
      setTimeout(() => {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 0.6
        })
      }, 10)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
  },
  created() {
    this.openLoadingInDiv()
    this.$store.dispatch('admin_api/fetchDataListVillages')
    this.filterStartDate = moment().format('D MMMM yyyy');
    this.filterStartTime = moment().subtract(60, 'minutes').format('HH:mm')
    this.filterEndDate = moment().format('D MMMM yyyy');
    this.filterEndTime = moment().format('HH:mm')
    // this.$store.dispatch('map/fetchMaps', { })
    this.$store.dispatch('admin_api/filterReport', {
      filterStartDate: this.filterStartDate,
      filterStartTime: this.filterStartTime,
      filterEndDate: this.filterEndDate,
      filterEndTime: this.filterEndTime
    }).then((res) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
        })
    // this.$store.dispatch('admin_api/fetchDataListReports', {}).then((res) => {
    //   this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    // })
  },
  watch: {
    '$store.state.windowWidth'(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4
      }
    }
  },
  computed: {
    ...mapState({
      villages: state => state.admin_api.villages,
    }),
    maps() {
      return this.$store.state.map.maps
    },
    reports() {
      return this.$store.state.admin_api.reports
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 15
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    isFormValid() {
      return !this.errors.any() && this.filterMeasuringPoint && this.filterStartDate && this.filterStartTime && this.filterEndDate && this.filterEndTime
    }
  },
  filters: {
    dtSubtract(dt, duration, unit) {
      return moment.utc(dt).subtract(duration, unit)
    },
    dtFormat(dt, format) {
      return moment.utc(dt).format(format)
    }
  }
}
</script>

<style lang="scss">
.con-vs-loading {
  z-index: 9999 !important;
}
</style>
